import React, { useEffect } from "react";
import logoFooter from "../assets/logoFooter.png";
import logo2 from "../assets/logo2.png";
import samoolah from "../assets/samoolah.png";
import { Link } from "react-router-dom";
import {
  FacebookFilled,
  InstagramFilled,
  LinkedinFilled,
  TikTokFilled,
  TwitterSquareFilled,
  XOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { fetchfooter } from "../redux/footerSlice";
import { useDispatch, useSelector } from "react-redux";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();
  const { footer, status, error } = useSelector((state) => state.footer);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchfooter());
    }
  }, [status, dispatch]);

  const SupportData =
    footer.find((content) => content.name === "support") || {};
  const emailData = footer.find((content) => content.name === "email") || {};
  const addressData =
    footer.find((content) => content.name === "العنوان") || {};
  const facebookData =
    footer.find((content) => content.name === "facebook") || {};
  const linkindData =
    footer.find((content) => content.name === "linkedIn") || {};
  const twitterData =
    footer.find((content) => content.name === "twitter") || {};

  const instaData =
    footer.find((content) => content.name === "Instagram") || {};

  const tiktokData = footer.find((content) => content.name === "Tiktok") || {};

  return (
    <div className="relative pb-14">
      <img
        src={logoFooter}
        className={`w-[280px] h-[350px] absolute right-0 bottom-0 z-0`}
      />
      <div
        className="px-20 max-lg:px-5 lg:py-20 border-t-4 border-[#FE9B71] relative z-10"
        style={{ borderRadius: "50px 50px 0px 0px" }}
      >
        <div className="grid grid-cols-5 max-lg:grid-cols-2 gap-10 max-lg:mt-8">
          <div className="col-span-2">
            <div className="flex items-center">
              <img src={logo2} className="w-[60px]" />
              <img
                src={samoolah}
                className={`w-[170px] ${language == "en" ? "ml-5" : "mr-5"}`}
              />
            </div>
            <p className="text-[#5B6A83] text-lg max-lg:text-base block mb-3 mt-8 ">
              {t("footer.description")}
            </p>
          </div>
          <div>
            <h2 className="text-[#283D63] text-xl font-semibold mb-4">
              {t("footer.company")}
            </h2>

            <Link to="/previewrequests" className="text-[#737E91] block mb-3">
              {t("footer.preview_requests")}
            </Link>
            <Link to="/services" className="text-[#737E91] block mb-3">
              {t("footer.services")}
            </Link>

            <Link to="/products" className="text-[#737E91] block mb-3">
              {t("Products")}
            </Link>
            <Link to="/store" className="text-[#737E91] block mb-3">
              {t("footer.store")}
            </Link>
            
          </div>
          <div>
            <h2 className="text-[#283D63] text-xl font-semibold mb-4">
              {t("footer.contacts")}
            </h2>
            <Link
              to={SupportData.value ? `tel:${SupportData.value}` : "/"}
              className="text-[#737E91] block mb-3"
            >
              {SupportData.value}
            </Link>
            <Link
              to={emailData.value ? `mailto:${emailData.value}` : "/"}
              className="text-[#737E91] block mb-3 max-lg:text-sm"
            >
              {emailData.value}
            </Link>
            <p className="text-[#737E91] block mb-3">
              {t("Uthman Ibn Affan Branch Rd, Al Izdihar, Riyadh 12487")}
            </p>
          </div>
          <div>
            <h2 className="text-[#283D63] text-xl font-semibold mb-4">
              {t("footer.help")}
            </h2>
            <Link to="/terms_conditions" className="text-[#737E91] block mb-3">
              {t("footer.terms_conditions")}
            </Link>
            <Link to="/politecs" className="text-[#737E91] block mb-3">
              {t("footer.privacy_policies")}
            </Link>
          </div>
        </div>
        <div className="flex items-center justify-end lg:pr-32">
          <h2
            className={`text-[#283D63] text-2xl font-semibold ${
              language == "en" ? "mr-8" : "ml-8"
            } max-lg:mt-3`}
          >
            {t("footer.socials")}
          </h2>
          {/* <Link to={facebookData.value} className="relative z-10">
            <FacebookFilled className="text-[#eaa182] text-3xl border-4 border-[#FCFBFA]" />
          </Link> */}

          <Link to={instaData.value} className="relative z-10">
            <InstagramFilled className="text-[#eaa182] text-3xl border-4 border-[#FCFBFA] bg-[#FCFBFA]" />
          </Link>

          <Link to={tiktokData.value} className="relative z-10">
            <TikTokFilled className="text-[#eaa182] text-3xl border-4 border-[#FCFBFA] bg-[#FCFBFA] mx-8" />
          </Link>

          <Link to={twitterData.value} className="relative z-10">
            {/* <TwitterSquareFilled className="text-[#eaa182] text-3xl border-4 border-[#FCFBFA]" /> */}
            <XOutlined className="text-[#eaa182] text-3xl border-4 border-[#FCFBFA] bg-[#FCFBFA]"/>
          </Link>

          {/* <InstagramFilled className="text-[#eaa182] text-3xl border-4 border-[#FCFBFA] mx-8" />
          <TikTokFilled className="text-[#eaa182] text-3xl border-4 border-[#FCFBFA]" /> */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
